module.exports = __webpack_public_path__ + "static/media/Ringmaster.809dbdf7.jpg";